import { type } from "../types/index";
import ModelosService from "../services/modelos.services";
import { UpdateSecurityKey } from "../helpers/SecurityKey";

export const modelos = (user, idMarca, securityKey) => (dispatch) => {
    dispatch({type: type.clearMessage});
    dispatch({type: type.setLoading});
    dispatch({type: type.resetModelos});
    dispatch({type: type.resetAnios});
    dispatch({type: type.resetVersionVehiculo});
    return ModelosService.getModelos( user, idMarca, securityKey ).then(
        (data) => {
            dispatch({type: type.setLoading});
            if(data.Codigo === 0) {
                const reformateo = data.Tipo.map(item => {
                    const container = {};
                    container["label"] = item.Tipo;
                    container["value"] = item.IdTipo;
                    return container;
                });
                data.Tipo = reformateo;
                dispatch({
                    type: type.getModelos,
                    payload: data
                });
                
                UpdateSecurityKey(data.llaveSeguridad);
            } else {
                dispatch({
                    type: type.getModelosFail
                });
                dispatch({
                    type: type.setError,
                    payload: {
                        tipoError: data.Codigo,
                        mensajeError: data.Mensaje
                    }
                });
            }
            
            dispatch({
                type: type.textMessage,
                payload: data,
            });
            return Promise.resolve(data);
        },
        (error) => {
            const message = (error.response && error.response.data && error.response.data.message) ||
            error.message || error.toString();
            dispatch({type: type.setLoading});
            dispatch({
                type: type.getModelosFail
            });
            dispatch({
                type: type.textMessage,
                payload: message
            });
            dispatch({
                type: type.setError,
                payload: {
                    tipoError: 0,
                    mensajeError: message
                }
            });
            return Promise.reject(error);
        }
    )
}

export const modelosSeguro = (user, idMarca, securityKey) => (dispatch) => {
    dispatch({type: type.clearMessage});
    dispatch({type: type.setLoading});
    dispatch({type: type.resetModelos});
    dispatch({type: type.resetAnios});
    dispatch({type: type.resetVersionVehiculo});
    return ModelosService.getModelosSeguro( user, idMarca, securityKey ).then(
        (data) => {
            dispatch({type: type.setLoading});
            if(data.Codigo === 0) {
                const reformateo = data.Tipo.map(item => {
                    const container = {};
                    container["label"] = item.Tipo;
                    container["value"] = item.IdTipo;
                    return container;
                });
                data.Tipo = reformateo;
                dispatch({
                    type: type.getModelos,
                    payload: data
                });
                
                UpdateSecurityKey(data.llaveSeguridad);
            } else {
                dispatch({
                    type: type.getModelosFail
                });
                dispatch({
                    type: type.setError,
                    payload: {
                        tipoError: data.Codigo,
                        mensajeError: data.Mensaje
                    }
                });
            }
            
            dispatch({
                type: type.textMessage,
                payload: data,
            });
            return Promise.resolve(data);
        },
        (error) => {
            const message = (error.response && error.response.data && error.response.data.message) ||
            error.message || error.toString();
            dispatch({type: type.setLoading});
            dispatch({
                type: type.getModelosFail
            });
            dispatch({
                type: type.textMessage,
                payload: message
            });
            dispatch({
                type: type.setError,
                payload: {
                    tipoError: 0,
                    mensajeError: message
                }
            });
            return Promise.reject(error);
        }
    )
}
